import { deleteRequest, post, put } from '..';

const updateTemplateGroup = async (
  Name: string = null,
  ButtonPrototypeGroupId: string = null,
  toDelete: boolean = false,
) => {
  const endpoint: string = 'templates/groups';
  if (toDelete) return deleteRequest(endpoint, { ButtonPrototypeGroupId });
  if (ButtonPrototypeGroupId) return put(endpoint, { Name, ButtonPrototypeGroupId });
  return post(endpoint, { Name });
};

export default updateTemplateGroup;
